/*
  Markenkit v2: Hintergrundvideos (video-banner) sparsam und sicher starten.
  - Ein Video spielt nur, solange es im Bild ist. Videos weiter unten laden dadurch erst, wenn sie ins Bild kommen.
  - iOS verweigert Autoplay im Stromsparmodus und zeigt dann einen Play-Knopf, der unter Text und Schleier liegt
    und sich nicht antippen lässt. Daher beim ersten Tippen oder Klicken irgendwo auf der Seite noch einmal versuchen.
    Den Knopf blendet kit-v2-sections.css aus, bis dahin steht das Poster.
*/
(function () {
  if (window.kitVideoAutoplay) return;
  window.kitVideoAutoplay = true;

  const visible = new Set();
  let waitingForGesture = false;

  const tryPlay = (video) => {
    if (!video.paused) return Promise.resolve(true);
    video.muted = true;
    video.playsInline = true;
    const result = video.play();
    return result && typeof result.then === 'function' ? result.then(() => true).catch(() => false) : Promise.resolve(!video.paused);
  };

  const retryOnGesture = () => {
    if (waitingForGesture) return;
    waitingForGesture = true;
    const handler = () => {
      waitingForGesture = false;
      ['touchend', 'click'].forEach((type) => document.removeEventListener(type, handler, true));
      visible.forEach(tryPlay);
    };
    ['touchend', 'click'].forEach((type) => document.addEventListener(type, handler, { capture: true, passive: true }));
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) {
          visible.add(target);
          tryPlay(target).then((played) => {
            if (!played) retryOnGesture();
          });
        } else {
          visible.delete(target);
          if (!target.paused) target.pause();
        }
      });
    },
    { rootMargin: '200px 0px' }
  );

  const watch = () => document.querySelectorAll('.video-background video').forEach((video) => observer.observe(video));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
  document.addEventListener('shopify:section:load', watch);
})();
